export const getAdvisors = (state) => {
  return state.advisors.data ? state.advisors.data : {};
};
